import { render, staticRenderFns } from "./incidents_report.vue?vue&type=template&id=b53c8b36"
import script from "./incidents_report.vue?vue&type=script&lang=js"
export * from "./incidents_report.vue?vue&type=script&lang=js"
import style0 from "./incidents_report.vue?vue&type=style&index=0&id=b53c8b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports